import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.payments_api.client_coupons;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
 baseURL: BASE_URL,
 headers: {
   'Content-Type': 'application/json'
 }
}));


export const getAllPaymentDiscounts = async (localId:number) => {
    return await retryWithBackoff(() => api.get(`/GetAllValidClientCouponsByLocalId/${localId}`, {
    }));
}

// GetClientCouponInformationByCouponCode/<string:coupon_code>

export const getClientCouponInformationByCouponCode = async (couponCode:string) => {
    return await retryWithBackoff(() => api.get(`/GetClientCouponInformationByCouponCode/${couponCode}`));
}

//CreateClientCoupon receives {client_id: number, payment_coupon_id: number}

export const createClientCoupon = async (clientId:number | null, paymentCouponId:number) => {
    return await retryWithBackoff(() => api.post(`/CreateClientCoupon`, {"client_id": clientId, "payment_coupon_id": paymentCouponId}));
}

// /ValidateClientCoupon/<string:coupon_code>/<int:local_id>'with payload {pedidos_ids: [1,2,3..]}

export const validateClientCoupon = async (couponCode:string, localId:number, selections:any[], receipt_id:number) => {
    return await retryWithBackoff(() => api.post(`/ValidateClientCoupon/${couponCode}/${localId}`, {"selections": selections, "receipt_id": receipt_id}));
}

export const setClientCouponValidation = async (couponCode: string, isValid: boolean) => {
    return await retryWithBackoff(() => api.post(`/SetClientCouponValidation/${couponCode}`, { is_valid: isValid }));
};